import { TaskStatus } from '../types';

export const taskStatusColors: Record<TaskStatus, string> = {
  todo: '#C24914',
  in_progress: '#FDAB3D',
  in_review: '#579BFC',
  done: '#00C875',
};

